<template>
    <b-modal id="modal-valida-email" ref="modal-valida-email" size="md" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <template v-slot:modal-header="{ close }">
            <div :class="'loading ' + (loading?'d-flex':'d-none')">
                <b-spinner
                    variant="primary"
                    style="width: 80px; height: 80px;border-width: 0.65em;"
                    label="Large Spinner"
                    v-if="loading"
                ></b-spinner>
            </div>
            <div class="steps-semaforo">
                <div class="step-circle" v-for="(s, index) in steps" :key="index" :class="stepClass(index)">
                    {{ index + 1 }}
                </div>
                <div v-show="step==3" class="step-circle success" key="final-step">
                    <font-awesome-icon  icon="check" />
                </div>
            </div>
        </template>
        <template v-slot:default="{ hide }">
            <div class="container">
                
                <div class="step" v-if="step==0">
                    <h1>Confirme seu e-mail</h1>
                    <template v-if="!isEmailNew">
                        <span>
                            O endereço de e-mail em seu cadastro é 
                            <br>
                            <strong>{{email}}</strong>
                            <br>
                            Não é seu endereço de email?
                        </span>
                        <a class="link" @click="alteraEmail">Altere o endereço de e-mail aqui.</a>
                    </template>
                    <template v-if="isEmailNew">
                        <span>
                            Digite abaixo o novo e-mail para seu cadastro 
                        </span>
                        <a class="link" @click="alteraEmail">Ou cancele a ação aqui.</a>
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-input-group-text>
                                    <b-icon icon="envelope" />
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input 
                                id="email"
                                v-model="email"
                                type="email"
                                trim
                                @blur.native="validaEmail"
                                placeholder="email@exemplo.com.br"
                                autocomplete="off"
                            />
                        </b-input-group>
                        <b-alert :show="alertEmailInvalido" fade variant="danger" class="text-center">E-mail informado inválido!</b-alert>
                        <b-alert :show="alertEmailExists" fade variant="danger" class="text-center">Já encontra-se usuário cadastrado com o e-mail informado!</b-alert>
                    </template>
                </div>
                <div class="step" v-if="step==1">
                    <h1>Verifique seu e-mail</h1>
                    <span>
                        Ao clicar em prosseguir será enviado um código via e-mail para
                        <br>
                        <strong>{{email}}</strong>
                        Se deseja confirmar essa ação clique em prosseguir.
                        <br>
                    </span>
                    <b-alert :show="alertErroEnvio" fade variant="danger" class="text-center">Erro ao enviar token para o e-mail informado.</b-alert>
                </div>
                <div class="step" v-if="step==2">
                    <h1>Verificação via token</h1>
                    <span>Digite o código de 6 dígitos que enviamos para seu email<br><strong>{{email}}</strong></span>
                    <div :class="'token-valida-container' + (falha_validacao ? ' valida-danger':'')">
                        <p class="label-token">Insira o código</p>
                        <div v-for="(char, index) in tokenValidacao" class="token-valida-input-container">
                            <input
                                :key="index"
                                v-model="tokenValidacao[index]"
                                @input="handleInput2fa(index, $event)"
                                @keydown="handleKeyDown2fa(index, $event)"
                                @paste="handlePaste2fa($event)"
                                class="token-valida-input"
                                maxlength="1"
                                :ref="`input_2fa_${index}`"
                                placeholder="_"
                            />
                        </div>
                        <div class="mb-4 mt-4">
                            <p class="token-error-msg" v-if="falha_validacao" fade>{{ falha_validacao_msg }}</p>
                            <p v-if="timer2fa.current > 0">Reenviar código em {{formatTimer(timer2fa.current)}}</p>
                            <p v-else>
                                <a class="link" @click="reenviarTokenValidacao()">Reenviar código <b-spinner id="loading-entrar" small type="grow" v-if="loading"></b-spinner></a>
                            </p>
                            <p>Se você não recebeu o código em seu email dentro de 2 minutos, por favor, atualize e verifique suas informações de contato ou considere verificar sua pasta e spam.</p>
                        </div>
                    </div>
                </div>
                <div class="step" v-if="step==3">
                    <h1>Parabéns!</h1>
                    <span>O email <strong>{{email}}</strong><br>foi validado com sucesso!</span>
                    <p>Agora você será redirecionado para continuar sua operação.</p>
                </div>
            </div>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button v-show="step<3" size="lg" variant="voltar" @click="voltar" class="mr-auto" ref="btnVoltar" id="btn-voltar">{{(step==0?'Cancelar':'Voltar')}}</b-button>
            <b-button v-show="step<3" size="lg" variant="prosseguir" @click="prosseguir" class="" ref="btnProsseguir" id="btn-prosseguir">{{step==2?'Confirmar':'Prosseguir'}}</b-button>
        </template>
    </b-modal>
</template>
<script>

import API from '@/services/api'
export default {
    props:{
        tipo: String,
    },
    data(){
        return{
            step: 0,
            steps:[
                'Confirmação de e-mail',
                'Verifique seu e-mail',
                'Verificação via token',
            ],
            tokenValidacao:Array(6).fill(""),
            falha_confirmacao:'',
            falha_confirmacao_msg:'',
            isEmailNew:false,
            alertEmailInvalido: false,
            alertEmailExists:false,
            loading: false,
            email:'',
            cpf:'',
            token: '',
            timer2fa:{current:0,value:120},
            falha_validacao: false,
            falha_validacao_msg: '',
            alertErroEnvio: false,
        }
    },
    methods: {
        async prosseguir(){
            this.loading = true;
            this.alertErroEnvio = false;
            if(this.step < 1) this.step++;
            else if(this.step == 1){
                let pass = await this.reenviarTokenValidacao();
                if(pass) this.step++;
                else this.alertErroEnvio = true;
            }
            else if(this.step == 2){
                let confirmacao = await this.confirmaTokenValidacao();
                if(confirmacao){
                    this.step++;
                    this.$emit('confirmaValidacaoEmail',{acao: true});
                    this.$bvModal.hide('modal-valida-email');
                }
            }
            this.loading = false;
        },
        voltar(){
            if(this.step == 0){
                this.$emit('cancelaValidacaoEmail',{acao:true});
                this.$bvModal.hide('modal-valida-email');
            }
            else{
                this.step--;
            }
        },
        alteraEmail(){
            this.isEmailNew = !this.isEmailNew;
            if(!this.isEmailNew) {
                let bt = document.getElementById('btn-prosseguir');
                this.alertEmailExists = false;
                this.alertEmailInvalido = false;
                bt.disabled = false;
                this.email = localStorage.getItem('usrEmail');
            }
        },
        stepClass(index) {
            if (index < this.step) {
                return 'prev-step';
            } else if (index === this.step) {
                return 'active-step';
            } else {
                return 'next-step';
            }
        },
        handleInput2fa(index, event) {
            if (event.target.value.match(/[0-9a-zA-Z]/)) {
                this.falha_validacao = false
                this.$set(this.tokenValidacao, index, event.target.value);
                if (index < this.tokenValidacao.length - 1) {
                this.$refs[`input_2fa_${index + 1}`][0].focus();
                }
            } else {
                this.$set(this.tokenValidacao, index, "");
            }
        },
        handleKeyDown2fa(index, event) {
            if (event.key === "ArrowRight" && index < this.tokenValidacao.length - 1) {
                this.$refs[`input_2fa_${index + 1}`][0].focus();
            } else if (event.key === "ArrowLeft" && index > 0) {
                this.$refs[`input_2fa_${index - 1}`][0].focus();
            } else if (event.key === "Tab") {
                event.preventDefault();
                if (event.shiftKey) {
                    if (index > 0) {
                        this.$refs[`input_2fa_${index - 1}`][0].focus();
                    }
                } else {
                    if (index < this.tokenValidacao.length - 1) {
                        this.$refs[`input_2fa_${index + 1}`][0].focus();
                    }
                }
            } else if (event.key === "Backspace" || event.key === "Delete") {
                event.preventDefault();
                this.falha_validacao = false
                this.$set(this.tokenValidacao, index, "");
                if (index > 0) {
                    this.$refs[`input_2fa_${index - 1}`][0].focus();
                }
            } else if(event.key.match(/[0-9a-zA-Z]/) && event.key.length === 1 && !event.ctrlKey){
                if(this.tokenValidacao[index] !== '') {
                    this.falha_validacao = false
                    this.$set(this.tokenValidacao, index, event.key);
                    event.preventDefault();
                    this.$refs[`input_2fa_${index + 1}`][0].focus();
                }
            }
        },
        handlePaste2fa(event) {
            event.preventDefault();
            this.falha_validacao = false
            let pastedData = event.clipboardData.getData("text/plain");
            let pastedCharacters = pastedData.split("");
            let inputIndex = 0;
            pastedCharacters.forEach((char, index) => {
                if(char.match(/[0-9a-zA-Z]/) && inputIndex < this.tokenValidacao.length){
                this.$set(this.tokenValidacao, inputIndex, char);
                inputIndex++;
                }
            });
            if(inputIndex < this.tokenValidacao.length){
                this.$refs[`input_2fa_${inputIndex}`][0].focus();
            }
            else{
                this.$nextTick(() => {
                    this.$refs.btnProsseguir.focus();
                });
            }
        },
        confirmaTokenValidacao(){
            return new Promise((resolve, reject) => {
                let data = {
                    token: this.token,
                    token2fa: this.tokenValidacaoString,
                    email: this.email
                };
                API.post("/user/validate/email/token", data).then((res) => {
                    let response = res.data
                    localStorage.setItem("usrEmail", response.email);
                    resolve(response.success);                       
                }).catch((error) => {
                    let res = error.response.data
                    if (res.error === 1)
                        this.falha_validacao_msg = 'CPF não encontrado.';
                    else if (res.error === 3)
                        this.falha_validacao_msg = 'Token inválido.';
                    else {
                        this.falha_validacao_msg = 'token inválido.';
                        this.falha_validacao = true;
                    }
                    throw new Error(false);
                });
            });
        },
        reenviarTokenValidacao(){
            return new Promise((resolve, reject) => {
                this.loading = true;
                this.falha_validacao = false;
                let data = {
                    token: this.token,
                    email: this.email,
                    token2faOpcao: 'email',
                    tipo: this.tipo
                };
                API.post("/user/gerarToken", data).then((res) => {
                    this.timer2fa.current = this.timer2fa.value;
                    this.tokenValidacao = Array(6).fill("");
                    this.loading = false;
                    resolve(true);
                }).catch((error) => {
                    this.loading = false;
                    throw new Error(false);
                });                
            });
            
        },
        formatTimer(time){
            return new Date(time * 1000).toISOString().substring(14, 19)
        },
        async validaEmail() {
            this.alertEmailExists = false;
            this.alertEmailInvalido = false;
            this.loading = true;

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            let valid = emailRegex.test(this.email);
            let bt = document.getElementById('btn-prosseguir')

            if(valid){
                const emailExiste = await this.emailExists();
                if(emailExiste){
                    this.alertEmailExists = true
                    bt.disabled = true
                    document.getElementById('email').parentNode.parentNode.classList.add("is-invalid")
                    document.getElementById('email').classList.add("is-invalid")
                    this.loading = false;
                }
                else{
                    this.alertEmailExists = false
                    this.alertEmailInvalido = false
                    bt.disabled = false
                    document.getElementById('email').parentNode.parentNode.classList.remove("is-invalid")
                    document.getElementById('email').classList.remove("is-invalid")
                    this.loading = false;
                    return 0;
                }
            }
            else {
                this.alertEmailInvalido = true
                bt.disabled = true
                document.getElementById('email').parentNode.parentNode.classList.add("is-invalid")
                document.getElementById('email').classList.add("is-invalid")
                this.loading = false;
                return 0;
            }            
        },
        emailExists() {
            return new Promise((resolve, reject) => {
                let self = this
                const dados = { email: this.email };
                if (this.email){       
                    API.post(`usuario/email`,dados).then((res) => {
                        resolve(res.data.exists);
                    });
                }
                else throw new Error(false);
            });
        },
    },
    computed: {
        tokenValidacaoString: function(){
            return this.tokenValidacao.join('').toUpperCase(); 
        },
    },
    watch: {
        'timer2fa.current': {
            handler(value) {
                if (value > 0) setTimeout(() => {this.timer2fa.current--;}, 1000);
            },
            immediate: true,
        }
    },
    created(){
        this.email = localStorage.getItem('usrEmail');
        this.cpf = localStorage.getItem('usrCpf');
        this.token = localStorage.getItem('jwtToken');
    },
}
</script>
<style scoped>
    h1{
        font: normal normal bold 25px/20px  'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5;
        text-align: center;
        margin-bottom: 24px;
    }
    span{
        text-align: center;
        font: normal normal normal 15px/20px 'Kanit', sans-serif;
        letter-spacing: 0px;
        margin-bottom:24px;
        max-width: 280px;
    }
    p{
        font: normal normal normal 15px/20px 'Kanit', sans-serif;
        letter-spacing: 0px;
        margin-bottom:24px;
        max-width: 280px;
    }
    a{
        text-align: center;
        font: normal normal bold 15px/20px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #597EB5 !important;
        margin-bottom:18px;

    }
    .step{
        display: flex;
        flex-flow:column;
        align-items:center;
        justify-content:center;
    }
    .steps-semaforo{
        display: flex;
        margin: 0 auto;
        width: fit-content;
    }
    .step-progress {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
    }

    .step-circle {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        color: white;
        margin: 0 10px;
    }

    .prev-step {background-color: #4780f1;}
    .active-step {background-color: #1aceb5;}
    .next-step {background-color: #c3c3c3;}
    .success {background-color: #28a745;}

    .step-circle:not(:first-child):before {
        content: '';
        width: 20px;
        height: 2px;
        position: absolute;
        margin-left: -60px;
        background-color: #4780f1;

    }
    .step-circle.next-step:before {
        background-color: #c3c3c3;
    }
    .step-circle.success:before {
        background-color: #28a745;
    }

    button.btn-voltar,
    button.btn-prosseguir{
        text-align: left;
        font: normal normal bold 15px/18px 'Kanit', sans-serif;
        letter-spacing: 0px;
        height: 48px;
    }
    button.btn-voltar {
        border:none;
        background-color: #FFFFFF;
        border: 3px solid transparent;
        color: #4780f1;
    }
    button.btn-voltar:hover{
        border: 3px solid #4780f1;
    }
    button.btn-prosseguir{
        border: 3px solid #597EB5;
        background: #ffffff;
        color: #597EB5;
    }
    button.btn-prosseguir:hover{
        border: 3px solid #4780f1;
        background: #4780f1;
        color: #ffffff;
    }
    button.btn-prosseguir:disabled:hover{
        border: 3px solid #597EB5;
        background: #ffffff;
        color: #597EB5;
        cursor: not-allowed;
    }
    .input-group{
        margin-bottom: 24px;
    }
    .alert.alert-danger{
        width:100%;
        background: #F8CBCB 0% 0% no-repeat padding-box;
        color: #702727;
        font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
        text-decoration: none;
    }
    .loading{
        position: absolute;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        background: #00000060;
        z-index: 10000;
        left: 0;
        top: 0;
    }
    .token-valida-container {
        display: flex;
        gap: 5px;
        align-items: center;
        justify-content: center;
        width: 100%;
        flex-wrap: wrap;
        max-width: 303px;
    }
    .token-valida-container .token-valida-input-container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .token-valida-container .token-valida-input-container input.token-valida-input {
        background: transparent;
        border: 1px solid #c3c3c3;
        width: 30px;
        height: 48px;
        text-transform: uppercase;
        text-align: center;
        vertical-align: middle;
        font: normal normal bold 22px/22px 'Kanit', sans-serif;
        letter-spacing: 0px;
        color: #495057;
        margin-bottom: 0px;
    }
    .token-valida-container .token-valida-input-container input.token-valida-input:focus,
    .token-valida-container .token-valida-input-container input.token-valida-input:focus-visible{
        border-color: #4780F1 !important;
        border-width: 2px !important;
            outline: none !important;
    }
    .token-valida-container .token-valida-input-container input.token-login-input:focus::placeholder,
    .token-valida-container .token-valida-input-container input.token-valida-input:focus-visible::placeholder{
        color: transparent;
    }
    .token-valida-container .token-valida-input-container:nth-child(4)::after {
        content: '';
        width: 9px;
        height: 2px;
        background: #c3c3c3;
        margin: 0px 5px 0px 10px;
    }
    .token-valida-container.valida-danger p.label-token{
        color: #1ACEB5;
        margin-left: 38px;
    }
    .token-valida-container.valida-danger  .token-valida-input-container input.token-valida-input{
        border: 1px solid #1ACEB5;
        color: #1ACEB5;
        animation: tremble 5s ease-in-out 3;
    }
    .token-error-msg{
        color: #1ACEB5;
        font-weight: bold;
        margin: 0px;
        text-align: center;
        width:100%;
    }
    .token-valida-container.valida-danger .token-valida-input-container:nth-child(4)::after {
        background-color: #1ACEB5;
    }
    p.label-token{
        width: 100%;
        margin-bottom: 5px;
        padding-left: 25px;
    }
</style>
